var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_c('img',{staticClass:"company-logo",attrs:{"alt":_vm.appName,"src":_vm.logoSrc}})]),_c('p',{staticClass:"p-t-10 login-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }